/*
 * THIS FILE IS GENERATED — DO NOT EDIT.
 *
 * Source:    swagger30-api.json
 * Generator: bin/generateEndpointOperations.ts
 * Regen:     npm run generate:clients (from sst/)
 */

import type {
  AccountEventRequest,
  AccountEventRequests,
  AccountEventsResponse,
  AcknowledgementLogPage,
  AcknowledgementPage,
  AcknowledgementWriteRequest,
  AcknowledgementWriteResult,
  AssignmentIntervalPage,
  AsyncEcho,
  BootstrapDeviceDrivingStatuses,
  BootstrapDriverTranscripts,
  BootstrapLatestUnreadEventPerFeed,
  BootstrapWorkspaceAccounts,
  BootstrapWorkspaceCommandAliases,
  BootstrapWorkspaceFeedGroupMemberships,
  BootstrapWorkspaceFeedGroups,
  BootstrapWorkspaceFeedItemEventLog,
  BootstrapWorkspaceFeedItems,
  BootstrapWorkspaceFeedPermissions,
  BootstrapWorkspaceFeedPreferences,
  BootstrapWorkspaceFeeds,
  BootstrapWorkspaceMembershipAvailabilities,
  BootstrapWorkspaceMembershipTags,
  BootstrapWorkspaceMemberships,
  BootstrapWorkspaceTags,
  BootstrapWorkspaceTemplates,
  BootstrapWorkspacesResponse,
  CallConfiguration,
  CreateCallEventRequest,
  CreateCallRequest,
  CreateContentEventRequest,
  CreateContentEventRequests,
  CreatePingResponse,
  CreateWorkspaceDirectInvitationRequest,
  CreateWorkspaceDirectInvitationResponse,
  CreateWorkspaceScheduledBroadcastRequest,
  CreateWorkspaceScheduledBroadcastResponse,
  CreateWorkspaceTemplateRequest,
  CreateWorkspaceTemplateResponse,
  CreateWorkspaceWorkflowItemRequest,
  DeleteWorksapceFeedItemResponse,
  DeviceRegistration,
  DeviceRegistrationRequest,
  DriverCurrentRoutes,
  DriverFeedPreferenceRequest,
  GetScheduledBroadcastsResponse,
  GetWorkspaceFeedEventsResponse,
  GetWorkspaceFeedItemsResponse,
  GetWorkspaceFeedPermissionsResponse,
  GetWorkspaceInvitationsResponse,
  GetWorkspaceTemplatesResponse,
  GetWorkspaceWorkflowItemsResponse,
  HandsFreeStatusRequest,
  HandsFreeStatusResponse,
  HeartbeatRequest,
  HeartbeatRequests,
  HeartbeatResponse,
  LocationsRequest,
  LocationsResponse,
  MemberDeviceUsageResponseSchema,
  MembershipHosClocks,
  PublishBroadcastRequest,
  PublishBroadcastResponse,
  PublishTTSRequest,
  PublishTTSResponse,
  PublishToWorkspaceFeedRequest,
  PublishWorkspaceWorkflowItemRequest,
  SearchFeedsRequest,
  SearchFeedsResponse,
  SearchMessageResponse,
  SearchMessagesRequest,
  SearchTagValuesResponse,
  TaskPage,
  TaskPinBoardPage,
  TaskPinBoardWriteRequest,
  TaskWriteRequest,
  TaskWriteResult,
  TmsEventStreamPage,
  TranscriptionFormatType,
  UnactivatedMembersResponseSchema,
  UnreadMessageCountResponse,
  UpdateFeedPreferenceByFeedGroupResponse,
  UpdateFeedPreferenceRequest,
  UpdateFeedPreferenceResponse,
  UpdateWorkspaceMembershipConfigRequest,
  UpdateWorkspaceMembershipConfigResponse,
  UpdateWorkspaceMembershipRequest,
  UpdateWorkspaceMembershipResponse,
  UpdateWorkspaceScheduledBroadcastRequest,
  UpdateWorkspaceScheduledBroadcastResponse,
  UpdateWorkspaceTemplateRequest,
  UpdateWorkspaceTemplateResponse,
  UploadDeviceLogs,
  WakeWordCalibrationResultRequest,
  WakeWordCalibrationResultResponse,
  WorkspaceCurrentRoutesResponse,
  WorkspaceFeedItemContentRequest,
  WorkspaceFeedItemContentResponse,
  WorkspaceFeedItemLocationsRequest,
  WorkspaceFeedItemLocationsResponse,
  WorkspaceFeedItemOldestEventsRequest,
  WorkspaceFeedItemOldestEventsResponse,
  WorkspaceHosClocksResponse,
  WsItem,
  WsPublishedWorkflowItem,
  WsWorkflowItem,
} from "./data-contracts";
import type { Transport } from "../transport";

/**
 * `POST /v1/account-event`
 *
 * Account event response
 */
export function postAccountEvent(
  transport: Transport,
  args: { body: AccountEventRequest },
): Promise<AccountEventsResponse> {
  return transport<AccountEventsResponse>({
    method: "POST",
    path: "/v1/account-event",
    body: args.body,
    telemetry: { route: "/v1/account-event", method: "POST", rowsField: "events" },
  });
}

/**
 * `POST /v1/account-events`
 *
 * Account events response
 */
export function postAccountEvents(
  transport: Transport,
  args: { body: AccountEventRequests },
): Promise<AccountEventsResponse> {
  return transport<AccountEventsResponse>({
    method: "POST",
    path: "/v1/account-events",
    body: args.body,
    telemetry: { route: "/v1/account-events", method: "POST", rowsField: "events" },
  });
}

/**
 * `GET /v1/bootstrap/workspaces`
 *
 * Bootstrap workspaces data
 */
export function getBootstrapWorkspaces(transport: Transport): Promise<BootstrapWorkspacesResponse> {
  return transport<BootstrapWorkspacesResponse>({
    method: "GET",
    path: "/v1/bootstrap/workspaces",
    telemetry: { route: "/v1/bootstrap/workspaces", method: "GET" },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/accounts`
 *
 * Bootstrap workspace accounts
 */
export function getBootstrapWorkspacesAccounts(
  transport: Transport,
  args: { id: string; page?: number | null; pageSize?: number; timestamp?: string | null },
): Promise<BootstrapWorkspaceAccounts> {
  return transport<BootstrapWorkspaceAccounts>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/accounts`,
    query: { page: args.page, pageSize: args.pageSize, timestamp: args.timestamp },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/accounts",
      method: "GET",
      rowsField: "accounts",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/alias-feed-latest-owner-items`
 *
 * Bootstrap workspace alias feed latest owner items
 */
export function getBootstrapWorkspacesAliasFeedLatestOwnerItems(
  transport: Transport,
  args: { id: string; page?: number | null; pageSize?: number; timestamp?: string | null },
): Promise<BootstrapWorkspaceFeedItems> {
  return transport<BootstrapWorkspaceFeedItems>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/alias-feed-latest-owner-items`,
    query: { page: args.page, pageSize: args.pageSize, timestamp: args.timestamp },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/alias-feed-latest-owner-items",
      method: "GET",
      rowsField: "items",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/command-aliases`
 *
 * Bootstrap workspace command aliases
 */
export function getBootstrapWorkspacesCommandAliases(
  transport: Transport,
  args: { id: string; page?: number | null; pageSize?: number; timestamp?: string | null },
): Promise<BootstrapWorkspaceCommandAliases> {
  return transport<BootstrapWorkspaceCommandAliases>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/command-aliases`,
    query: { page: args.page, pageSize: args.pageSize, timestamp: args.timestamp },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/command-aliases",
      method: "GET",
      rowsField: "commandAliases",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/device-driving-statuses`
 *
 * Bootstrap workspace device driving statuses
 */
export function getBootstrapWorkspacesDeviceDrivingStatuses(
  transport: Transport,
  args: { id: string; page?: number | null; pageSize?: number; timestamp?: string | null },
): Promise<BootstrapDeviceDrivingStatuses> {
  return transport<BootstrapDeviceDrivingStatuses>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/device-driving-statuses`,
    query: { page: args.page, pageSize: args.pageSize, timestamp: args.timestamp },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/device-driving-statuses",
      method: "GET",
      rowsField: "deviceDrivingStatuses",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/driver-transcripts`
 *
 * Bootstrap driver transcripts and files per alias feed
 */
export function getBootstrapWorkspacesDriverTranscripts(
  transport: Transport,
  args: {
    id: string;
    page?: number | null;
    pageSize?: number;
    timestamp?: string | null;
    language?: string;
    format?: TranscriptionFormatType;
  },
): Promise<BootstrapDriverTranscripts> {
  return transport<BootstrapDriverTranscripts>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/driver-transcripts`,
    query: {
      page: args.page,
      pageSize: args.pageSize,
      timestamp: args.timestamp,
      language: args.language,
      format: args.format,
    },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/driver-transcripts",
      method: "GET",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/feed-group-memberships`
 *
 * Bootstrap workspace feed group memberships
 */
export function getBootstrapWorkspacesFeedGroupMemberships(
  transport: Transport,
  args: { id: string; page?: number | null; pageSize?: number; timestamp?: string | null },
): Promise<BootstrapWorkspaceFeedGroupMemberships> {
  return transport<BootstrapWorkspaceFeedGroupMemberships>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/feed-group-memberships`,
    query: { page: args.page, pageSize: args.pageSize, timestamp: args.timestamp },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/feed-group-memberships",
      method: "GET",
      rowsField: "feedGroupMemberships",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/feed-groups`
 *
 * Bootstrap workspace feed groups
 */
export function getBootstrapWorkspacesFeedGroups(
  transport: Transport,
  args: { id: string; page?: number | null; pageSize?: number; timestamp?: string | null },
): Promise<BootstrapWorkspaceFeedGroups> {
  return transport<BootstrapWorkspaceFeedGroups>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/feed-groups`,
    query: { page: args.page, pageSize: args.pageSize, timestamp: args.timestamp },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/feed-groups",
      method: "GET",
      rowsField: "feedGroups",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/feed-items`
 *
 * Bootstrap workspace feed items
 */
export function getBootstrapWorkspacesFeedItems(
  transport: Transport,
  args: {
    id: string;
    page?: number | null;
    pageSize?: number;
    timestamp?: string | null;
    feedId?: string;
    sortAscending?: boolean | null;
    itemId?: string;
    useCreatedAt?: boolean | null;
  },
): Promise<BootstrapWorkspaceFeedItems> {
  return transport<BootstrapWorkspaceFeedItems>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/feed-items`,
    query: {
      page: args.page,
      pageSize: args.pageSize,
      timestamp: args.timestamp,
      feedId: args.feedId,
      sortAscending: args.sortAscending,
      itemId: args.itemId,
      useCreatedAt: args.useCreatedAt,
    },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/feed-items",
      method: "GET",
      rowsField: "items",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/feed-items/event-log`
 *
 * One page of the feed-item event log: the readable items of the workspace, or of the feeds named by `feedIds`, oldest
 * first after `since`, newest first without it
 */
export function getBootstrapWorkspacesFeedItemsEventLog(
  transport: Transport,
  args: { id: string; since?: string; until?: string; cursor?: string; limit?: number; feedIds?: string },
): Promise<BootstrapWorkspaceFeedItemEventLog> {
  return transport<BootstrapWorkspaceFeedItemEventLog>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/feed-items/event-log`,
    query: { since: args.since, until: args.until, cursor: args.cursor, limit: args.limit, feedIds: args.feedIds },
    telemetry: { route: "/v1/bootstrap/workspaces/{id}/feed-items/event-log", method: "GET", rowsField: "items" },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/feed-permissions`
 *
 * Bootstrap workspace feed permissions
 */
export function getBootstrapWorkspacesFeedPermissions(
  transport: Transport,
  args: { id: string; page?: number | null; pageSize?: number; timestamp?: string | null; mine?: boolean | null },
): Promise<BootstrapWorkspaceFeedPermissions> {
  return transport<BootstrapWorkspaceFeedPermissions>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/feed-permissions`,
    query: { page: args.page, pageSize: args.pageSize, timestamp: args.timestamp, mine: args.mine },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/feed-permissions",
      method: "GET",
      rowsField: "permissions",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/feed-preferences`
 *
 * Bootstrap workspace feed preferences
 */
export function getBootstrapWorkspacesFeedPreferences(
  transport: Transport,
  args: {
    id: string;
    page?: number | null;
    pageSize?: number;
    timestamp?: string | null;
    mine?: boolean | null;
    feedId?: string;
  },
): Promise<BootstrapWorkspaceFeedPreferences> {
  return transport<BootstrapWorkspaceFeedPreferences>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/feed-preferences`,
    query: {
      page: args.page,
      pageSize: args.pageSize,
      timestamp: args.timestamp,
      mine: args.mine,
      feedId: args.feedId,
    },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/feed-preferences",
      method: "GET",
      rowsField: "feedPreferences",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/feeds`
 *
 * Bootstrap workspace feed preferences
 */
export function getBootstrapWorkspacesFeeds(
  transport: Transport,
  args: {
    id: string;
    page?: number | null;
    pageSize?: number;
    timestamp?: string | null;
    mine?: boolean | null;
    feedId?: string;
  },
): Promise<BootstrapWorkspaceFeeds> {
  return transport<BootstrapWorkspaceFeeds>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/feeds`,
    query: {
      page: args.page,
      pageSize: args.pageSize,
      timestamp: args.timestamp,
      mine: args.mine,
      feedId: args.feedId,
    },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/feeds",
      method: "GET",
      rowsField: "feeds",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/latest-unread-event-per-feed`
 *
 * Bootstrap workspace latest unread event per feed
 */
export function getBootstrapWorkspacesLatestUnreadEventPerFeed(
  transport: Transport,
  args: { id: string; page?: number | null; pageSize?: number; timestamp?: string | null },
): Promise<BootstrapLatestUnreadEventPerFeed> {
  return transport<BootstrapLatestUnreadEventPerFeed>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/latest-unread-event-per-feed`,
    query: { page: args.page, pageSize: args.pageSize, timestamp: args.timestamp },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/latest-unread-event-per-feed",
      method: "GET",
      rowsField: "events",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/latest-unread-event-per-feed-for-organizers`
 *
 * Bootstrap workspace latest unread event per feed for organizers
 */
export function getBootstrapWorkspacesLatestUnreadEventPerFeedForOrganizers(
  transport: Transport,
  args: { id: string; page?: number | null; pageSize?: number; timestamp?: string | null },
): Promise<BootstrapLatestUnreadEventPerFeed> {
  return transport<BootstrapLatestUnreadEventPerFeed>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/latest-unread-event-per-feed-for-organizers`,
    query: { page: args.page, pageSize: args.pageSize, timestamp: args.timestamp },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/latest-unread-event-per-feed-for-organizers",
      method: "GET",
      rowsField: "events",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/non-alias-feed-latest-items`
 *
 * Bootstrap workspace non-alias feed latest items
 */
export function getBootstrapWorkspacesNonAliasFeedLatestItems(
  transport: Transport,
  args: { id: string; page?: number | null; pageSize?: number; timestamp?: string | null },
): Promise<BootstrapWorkspaceFeedItems> {
  return transport<BootstrapWorkspaceFeedItems>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/non-alias-feed-latest-items`,
    query: { page: args.page, pageSize: args.pageSize, timestamp: args.timestamp },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/non-alias-feed-latest-items",
      method: "GET",
      rowsField: "items",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/tags`
 *
 * Bootstrap workspace tags
 */
export function getBootstrapWorkspacesTags(
  transport: Transport,
  args: { id: string; page?: number | null; pageSize?: number; timestamp?: string | null },
): Promise<BootstrapWorkspaceTags> {
  return transport<BootstrapWorkspaceTags>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/tags`,
    query: { page: args.page, pageSize: args.pageSize, timestamp: args.timestamp },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/tags",
      method: "GET",
      rowsField: "tags",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/templates`
 *
 * Bootstrap workspace templates
 */
export function getBootstrapWorkspacesTemplates(
  transport: Transport,
  args: { id: string; page?: number | null; pageSize?: number; timestamp?: string | null },
): Promise<BootstrapWorkspaceTemplates> {
  return transport<BootstrapWorkspaceTemplates>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/templates`,
    query: { page: args.page, pageSize: args.pageSize, timestamp: args.timestamp },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/templates",
      method: "GET",
      rowsField: "templates",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/workspace-membership-availabilities`
 *
 * Bootstrap workspace membership availabilities
 */
export function getBootstrapWorkspacesWorkspaceMembershipAvailabilities(
  transport: Transport,
  args: { id: string; page?: number | null; pageSize?: number; timestamp?: string | null },
): Promise<BootstrapWorkspaceMembershipAvailabilities> {
  return transport<BootstrapWorkspaceMembershipAvailabilities>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/workspace-membership-availabilities`,
    query: { page: args.page, pageSize: args.pageSize, timestamp: args.timestamp },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/workspace-membership-availabilities",
      method: "GET",
      rowsField: "membershipAvailabilities",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/workspace-memberships`
 *
 * Bootstrap workspace memberships
 */
export function getBootstrapWorkspacesWorkspaceMemberships(
  transport: Transport,
  args: { id: string; page?: number | null; pageSize?: number; timestamp?: string | null },
): Promise<BootstrapWorkspaceMemberships> {
  return transport<BootstrapWorkspaceMemberships>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/workspace-memberships`,
    query: { page: args.page, pageSize: args.pageSize, timestamp: args.timestamp },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/workspace-memberships",
      method: "GET",
      rowsField: "workspaceMemberships",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/bootstrap/workspaces/{id}/workspace-memberships/tags`
 *
 * Bootstrap workspace membership tags
 */
export function getBootstrapWorkspacesWorkspaceMembershipsTags(
  transport: Transport,
  args: { id: string; page?: number | null; pageSize?: number; timestamp?: string | null },
): Promise<BootstrapWorkspaceMembershipTags> {
  return transport<BootstrapWorkspaceMembershipTags>({
    method: "GET",
    path: `/v1/bootstrap/workspaces/${args.id}/workspace-memberships/tags`,
    query: { page: args.page, pageSize: args.pageSize, timestamp: args.timestamp },
    telemetry: {
      route: "/v1/bootstrap/workspaces/{id}/workspace-memberships/tags",
      method: "GET",
      rowsField: "workspaceMembershipTags",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `POST /v1/call/{callId}`
 *
 * Create call configuration
 */
export function postCall(
  transport: Transport,
  args: { callId: string; body: CreateCallRequest },
): Promise<CallConfiguration> {
  return transport<CallConfiguration>({
    method: "POST",
    path: `/v1/call/${args.callId}`,
    body: args.body,
    telemetry: { route: "/v1/call/{callId}", method: "POST" },
  });
}

/**
 * `POST /v1/call/{callId}/call-event`
 *
 * Create call event
 */
export function postCallCallEvent(
  transport: Transport,
  args: { callId: string; body: CreateCallEventRequest },
): Promise<void> {
  return transport<void>({
    method: "POST",
    path: `/v1/call/${args.callId}/call-event`,
    body: args.body,
    telemetry: { route: "/v1/call/{callId}/call-event", method: "POST" },
  });
}

/**
 * `POST /v1/content/{contentId}/events`
 *
 * Create content event
 */
export function postContentEvents(
  transport: Transport,
  args: { contentId: string; body: CreateContentEventRequest },
): Promise<void> {
  return transport<void>({
    method: "POST",
    path: `/v1/content/${args.contentId}/events`,
    body: args.body,
    telemetry: { route: "/v1/content/{contentId}/events", method: "POST" },
  });
}

/**
 * `POST /v1/content/{contentId}/events-batch`
 *
 * Create batch content events
 */
export function postContentEventsBatch(
  transport: Transport,
  args: { contentId: string; body: CreateContentEventRequests },
): Promise<void> {
  return transport<void>({
    method: "POST",
    path: `/v1/content/${args.contentId}/events-batch`,
    body: args.body,
    telemetry: { route: "/v1/content/{contentId}/events-batch", method: "POST" },
  });
}

/**
 * `POST /v1/device/ping-response`
 *
 * Ping response recorded successfully
 */
export function postDevicePingResponse(transport: Transport, args: { body: CreatePingResponse }): Promise<void> {
  return transport<void>({
    method: "POST",
    path: "/v1/device/ping-response",
    body: args.body,
    telemetry: { route: "/v1/device/ping-response", method: "POST" },
  });
}

/**
 * `POST /v1/device/registration`
 *
 * Device registration response
 */
export function postDeviceRegistration(
  transport: Transport,
  args: { body: DeviceRegistrationRequest },
): Promise<DeviceRegistration> {
  return transport<DeviceRegistration>({
    method: "POST",
    path: "/v1/device/registration",
    body: args.body,
    telemetry: { route: "/v1/device/registration", method: "POST", rowsField: "additionalWakeWords" },
  });
}

/**
 * `POST /v1/echo/async`
 *
 * Async echo response
 */
export function postEchoAsync(transport: Transport, args: { body: AsyncEcho }): Promise<AsyncEcho> {
  return transport<AsyncEcho>({
    method: "POST",
    path: "/v1/echo/async",
    body: args.body,
    telemetry: { route: "/v1/echo/async", method: "POST" },
  });
}

/**
 * `POST /v1/logs`
 *
 * Device logs uploaded successfully
 */
export function postLogs(transport: Transport, args: { body: UploadDeviceLogs }): Promise<void> {
  return transport<void>({
    method: "POST",
    path: "/v1/logs",
    body: args.body,
    telemetry: { route: "/v1/logs", method: "POST" },
  });
}

/**
 * `GET /v1/messages/unread/count`
 *
 * Bootstrap workspace latest unread event per feed
 */
export function getMessagesUnreadCount(transport: Transport): Promise<UnreadMessageCountResponse> {
  return transport<UnreadMessageCountResponse>({
    method: "GET",
    path: "/v1/messages/unread/count",
    telemetry: { route: "/v1/messages/unread/count", method: "GET" },
  });
}

/**
 * `POST /v1/twilio/accept-call`
 *
 * Accept Call from Twilio
 */
export function postTwilioAcceptCall(transport: Transport): Promise<void> {
  return transport<void>({
    method: "POST",
    path: "/v1/twilio/accept-call",
    telemetry: { route: "/v1/twilio/accept-call", method: "POST" },
  });
}

/**
 * `POST /v1/twilio/call-status`
 *
 * Accept Call from Twilio
 */
export function postTwilioCallStatus(transport: Transport): Promise<void> {
  return transport<void>({
    method: "POST",
    path: "/v1/twilio/call-status",
    telemetry: { route: "/v1/twilio/call-status", method: "POST" },
  });
}

/**
 * `POST /v1/wakewordcalibration/result`
 *
 * Wake word calibration result
 */
export function postWakewordcalibrationResult(
  transport: Transport,
  args: { body: WakeWordCalibrationResultRequest },
): Promise<WakeWordCalibrationResultResponse> {
  return transport<WakeWordCalibrationResultResponse>({
    method: "POST",
    path: "/v1/wakewordcalibration/result",
    body: args.body,
    telemetry: { route: "/v1/wakewordcalibration/result", method: "POST" },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/acknowledgement-log/{subject}`
 *
 * One page of the subject's acknowledgement log. Rows are oldest first by creation, then id. `hasMore` says whether
 * the walk has another page, to be read now with `cursor`; once it is false, `cursor` names the next delta. A cursor
 * this API did not issue, one for another workspace or another log, or one older than the 7-day lookback is a 400, and
 * the client cold-starts
 */
export function getWorkspacesAcknowledgementLog(
  transport: Transport,
  args: { workspaceId: string; subject: "task"; since?: string; cursor?: string; limit?: number },
): Promise<AcknowledgementLogPage> {
  return transport<AcknowledgementLogPage>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/acknowledgement-log/${args.subject}`,
    query: { since: args.since, cursor: args.cursor, limit: args.limit },
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/acknowledgement-log/{subject}",
      method: "GET",
      rowsField: "acknowledgements",
    },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/acknowledgements/{subject}`
 *
 * One page of the subject's acknowledgement log, everything created after `since`, oldest first. A subject served by
 * `/workspaces/{workspaceId}/acknowledgement-log/{subject}`, today `task`, is a 404 here
 */
export function getWorkspacesAcknowledgements(
  transport: Transport,
  args: {
    workspaceId: string;
    subject: "feed" | "feed_item" | "stop_event" | "form_submission" | "hos_clock_violation" | "route_assignment_event" | "task";
    since: string;
    limit?: number;
    cursor?: string;
  },
): Promise<AcknowledgementPage> {
  return transport<AcknowledgementPage>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/acknowledgements/${args.subject}`,
    query: { since: args.since, limit: args.limit, cursor: args.cursor },
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/acknowledgements/{subject}",
      method: "GET",
      rowsField: "acknowledgements",
    },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/acknowledgements/{subject}`
 *
 * Which entries were recorded, a replayed id among them, and which were dropped for their target
 */
export function postWorkspacesAcknowledgements(
  transport: Transport,
  args: {
    workspaceId: string;
    subject: "feed" | "feed_item" | "stop_event" | "form_submission" | "hos_clock_violation" | "route_assignment_event" | "task";
    body: AcknowledgementWriteRequest;
  },
): Promise<AcknowledgementWriteResult> {
  return transport<AcknowledgementWriteResult>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/acknowledgements/${args.subject}`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/acknowledgements/{subject}", method: "POST" },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/assignment-intervals`
 *
 * The workspace's driver-on-vehicle assignment records: those overlapping [from, to] in history mode, or those opened
 * or closed by a transition written after `since` in delta mode
 */
export function getWorkspacesAssignmentIntervals(
  transport: Transport,
  args: { workspaceId: string; from?: string; to?: string; since?: string },
): Promise<AssignmentIntervalPage> {
  return transport<AssignmentIntervalPage>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/assignment-intervals`,
    query: { from: args.from, to: args.to, since: args.since },
    telemetry: { route: "/v1/workspaces/{workspaceId}/assignment-intervals", method: "GET", rowsField: "intervals" },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/current-routes`
 *
 * One page of a walk over the current, upcoming, and just-completed routes of the workspace's drivers: at most `limit`
 * drivers in membership-id order, of the whole fleet on a full walk, or on a delta walk only those whose routes may
 * have changed since the previous walk, plus those now on nothing. `hasMore` says whether the walk has another page,
 * and `cursor` names the walk's next page or the next walk
 */
export function getWorkspacesCurrentRoutes(
  transport: Transport,
  args: { workspaceId: string; cursor?: string; limit?: number },
): Promise<WorkspaceCurrentRoutesResponse> {
  return transport<WorkspaceCurrentRoutesResponse>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/current-routes`,
    query: { cursor: args.cursor, limit: args.limit },
    telemetry: { route: "/v1/workspaces/{workspaceId}/current-routes", method: "GET" },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/directInvitations`
 *
 * Direct invitations created successfully
 */
export function postWorkspacesDirectInvitations(
  transport: Transport,
  args: { workspaceId: string; body: CreateWorkspaceDirectInvitationRequest },
): Promise<CreateWorkspaceDirectInvitationResponse> {
  return transport<CreateWorkspaceDirectInvitationResponse>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/directInvitations`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/directInvitations", method: "POST" },
  });
}

/**
 * `PATCH /v1/workspaces/{workspaceId}/feed-groups/{feedGroupId}/membership/{membershipId}/preferences`
 *
 * Feed preferences for feed group updated successfully
 */
export function patchWorkspacesFeedGroupsMembershipPreferences(
  transport: Transport,
  args: { workspaceId: string; feedGroupId: string; membershipId: string; body: UpdateFeedPreferenceRequest },
): Promise<UpdateFeedPreferenceByFeedGroupResponse> {
  return transport<UpdateFeedPreferenceByFeedGroupResponse>({
    method: "PATCH",
    path: `/v1/workspaces/${args.workspaceId}/feed-groups/${args.feedGroupId}/membership/${args.membershipId}/preferences`,
    body: args.body,
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/feed-groups/{feedGroupId}/membership/{membershipId}/preferences",
      method: "PATCH",
      rowsField: "feedPreferences",
    },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/feed/items`
 *
 * Workspace feed items
 */
export function getWorkspacesFeedItems(
  transport: Transport,
  args: { workspaceId: string; page?: number | null; pageSize?: number | null; itemId?: string; timestamp?: string },
): Promise<GetWorkspaceFeedItemsResponse> {
  return transport<GetWorkspaceFeedItemsResponse>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/feed/items`,
    query: { page: args.page, pageSize: args.pageSize, itemId: args.itemId, timestamp: args.timestamp },
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/feed/items",
      method: "GET",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/feedItemContent`
 *
 * Workspace feed item content
 */
export function postWorkspacesFeedItemContent(
  transport: Transport,
  args: { workspaceId: string; body: WorkspaceFeedItemContentRequest },
): Promise<WorkspaceFeedItemContentResponse> {
  return transport<WorkspaceFeedItemContentResponse>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/feedItemContent`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/feedItemContent", method: "POST" },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/feedItemOldestEvents`
 *
 * Oldest events for feed items
 */
export function postWorkspacesFeedItemOldestEvents(
  transport: Transport,
  args: {
    workspaceId: string;
    page?: number | null;
    pageSize?: number | null;
    timestamp?: string;
    body: WorkspaceFeedItemOldestEventsRequest;
  },
): Promise<WorkspaceFeedItemOldestEventsResponse> {
  return transport<WorkspaceFeedItemOldestEventsResponse>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/feedItemOldestEvents`,
    query: { page: args.page, pageSize: args.pageSize, timestamp: args.timestamp },
    body: args.body,
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/feedItemOldestEvents",
      method: "POST",
      rowsField: "events",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/feedItems/locations`
 *
 * Feed item locations response
 */
export function postWorkspacesFeedItemsLocations(
  transport: Transport,
  args: { workspaceId: string; body: WorkspaceFeedItemLocationsRequest },
): Promise<WorkspaceFeedItemLocationsResponse> {
  return transport<WorkspaceFeedItemLocationsResponse>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/feedItems/locations`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/feedItems/locations", method: "POST", rowsField: "locations" },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/feeds/{feedId}/events`
 *
 * Workspace feed events
 */
export function getWorkspacesFeedsEvents(
  transport: Transport,
  args: { workspaceId: string; feedId: string; page?: number | null; pageSize?: number | null },
): Promise<GetWorkspaceFeedEventsResponse> {
  return transport<GetWorkspaceFeedEventsResponse>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/feeds/${args.feedId}/events`,
    query: { page: args.page, pageSize: args.pageSize },
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/feeds/{feedId}/events",
      method: "GET",
      rowsField: "events",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/feeds/{feedId}/items`
 *
 * Workspace feed items
 */
export function getWorkspacesFeedsItems(
  transport: Transport,
  args: { workspaceId: string; feedId: string; page?: number | null; pageSize?: number | null },
): Promise<GetWorkspaceFeedItemsResponse> {
  return transport<GetWorkspaceFeedItemsResponse>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/feeds/${args.feedId}/items`,
    query: { page: args.page, pageSize: args.pageSize },
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/feeds/{feedId}/items",
      method: "GET",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/feeds/{feedId}/latest-events`
 *
 * Workspace latest feed events
 */
export function getWorkspacesFeedsLatestEvents(
  transport: Transport,
  args: { workspaceId: string; feedId: string; page?: number | null; pageSize?: number | null },
): Promise<GetWorkspaceFeedEventsResponse> {
  return transport<GetWorkspaceFeedEventsResponse>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/feeds/${args.feedId}/latest-events`,
    query: { page: args.page, pageSize: args.pageSize },
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/feeds/{feedId}/latest-events",
      method: "GET",
      rowsField: "events",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `PATCH /v1/workspaces/{workspaceId}/feeds/{feedId}/membership/{membershipId}/preferences`
 *
 * Feed preferences updated successfully
 */
export function patchWorkspacesFeedsMembershipPreferences(
  transport: Transport,
  args: { workspaceId: string; feedId: string; membershipId: string; body: UpdateFeedPreferenceRequest },
): Promise<UpdateFeedPreferenceResponse> {
  return transport<UpdateFeedPreferenceResponse>({
    method: "PATCH",
    path: `/v1/workspaces/${args.workspaceId}/feeds/${args.feedId}/membership/${args.membershipId}/preferences`,
    body: args.body,
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/feeds/{feedId}/membership/{membershipId}/preferences",
      method: "PATCH",
    },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/feeds/{feedId}/oldest-events`
 *
 * Workspace oldest feed events
 */
export function getWorkspacesFeedsOldestEvents(
  transport: Transport,
  args: { workspaceId: string; feedId: string; page?: number | null; pageSize?: number | null },
): Promise<GetWorkspaceFeedEventsResponse> {
  return transport<GetWorkspaceFeedEventsResponse>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/feeds/${args.feedId}/oldest-events`,
    query: { page: args.page, pageSize: args.pageSize },
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/feeds/{feedId}/oldest-events",
      method: "GET",
      rowsField: "events",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/feeds/{feedId}/permissions`
 *
 * Workspace feed permissions
 */
export function getWorkspacesFeedsPermissions(
  transport: Transport,
  args: { workspaceId: string; feedId: string; page?: number | null; pageSize?: number | null },
): Promise<GetWorkspaceFeedPermissionsResponse> {
  return transport<GetWorkspaceFeedPermissionsResponse>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/feeds/${args.feedId}/permissions`,
    query: { page: args.page, pageSize: args.pageSize },
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/feeds/{feedId}/permissions",
      method: "GET",
      rowsField: "permissions",
      page: args.page ?? undefined,
      pageSize: args.pageSize ?? undefined,
    },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/handsfreestatus`
 *
 * Hands free status response
 */
export function postWorkspacesHandsfreestatus(
  transport: Transport,
  args: { workspaceId: string; body: HandsFreeStatusRequest },
): Promise<HandsFreeStatusResponse> {
  return transport<HandsFreeStatusResponse>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/handsfreestatus`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/handsfreestatus", method: "POST", rowsField: "data" },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/heartbeat`
 *
 * Heartbeat response
 */
export function postWorkspacesHeartbeat(
  transport: Transport,
  args: { workspaceId: string; body: HeartbeatRequest },
): Promise<HeartbeatResponse> {
  return transport<HeartbeatResponse>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/heartbeat`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/heartbeat", method: "POST" },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/heartbeats-batch`
 *
 * Heartbeat batch response
 */
export function postWorkspacesHeartbeatsBatch(
  transport: Transport,
  args: { workspaceId: string; body: HeartbeatRequests },
): Promise<HeartbeatResponse> {
  return transport<HeartbeatResponse>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/heartbeats-batch`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/heartbeats-batch", method: "POST" },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/hos-clocks`
 *
 * The hours of service of each of the workspace's drivers whose ELD holds a timer
 */
export function getWorkspacesHosClocks(
  transport: Transport,
  args: { workspaceId: string },
): Promise<WorkspaceHosClocksResponse> {
  return transport<WorkspaceHosClocksResponse>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/hos-clocks`,
    telemetry: { route: "/v1/workspaces/{workspaceId}/hos-clocks", method: "GET", rowsField: "drivers" },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/invitations`
 *
 * Success response
 */
export function getWorkspacesInvitations(
  transport: Transport,
  args: { workspaceId: string },
): Promise<GetWorkspaceInvitationsResponse> {
  return transport<GetWorkspaceInvitationsResponse>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/invitations`,
    telemetry: { route: "/v1/workspaces/{workspaceId}/invitations", method: "GET" },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/locations`
 *
 * Locations response
 */
export function postWorkspacesLocations(
  transport: Transport,
  args: { workspaceId: string; body: LocationsRequest },
): Promise<LocationsResponse> {
  return transport<LocationsResponse>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/locations`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/locations", method: "POST", rowsField: "data" },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/membership/{membershipId}/driver-feed-preferences`
 *
 * Driver feed preferences subscribed successfully
 */
export function postWorkspacesMembershipDriverFeedPreferences(
  transport: Transport,
  args: { workspaceId: string; membershipId: string; body: DriverFeedPreferenceRequest },
): Promise<UpdateFeedPreferenceByFeedGroupResponse> {
  return transport<UpdateFeedPreferenceByFeedGroupResponse>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/membership/${args.membershipId}/driver-feed-preferences`,
    body: args.body,
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/membership/{membershipId}/driver-feed-preferences",
      method: "POST",
      rowsField: "feedPreferences",
    },
  });
}

/**
 * `DELETE /v1/workspaces/{workspaceId}/membership/{membershipId}/driver-feed-preferences`
 *
 * Driver feed preferences unsubscribed successfully
 */
export function deleteWorkspacesMembershipDriverFeedPreferences(
  transport: Transport,
  args: { workspaceId: string; membershipId: string; body: DriverFeedPreferenceRequest },
): Promise<UpdateFeedPreferenceByFeedGroupResponse> {
  return transport<UpdateFeedPreferenceByFeedGroupResponse>({
    method: "DELETE",
    path: `/v1/workspaces/${args.workspaceId}/membership/${args.membershipId}/driver-feed-preferences`,
    body: args.body,
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/membership/{membershipId}/driver-feed-preferences",
      method: "DELETE",
      rowsField: "feedPreferences",
    },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/memberships/device-usage`
 *
 * Devices linked to every active member of the workspace, with each device's current mode
 */
export function getWorkspacesMembershipsDeviceUsage(
  transport: Transport,
  args: { workspaceId: string },
): Promise<MemberDeviceUsageResponseSchema> {
  return transport<MemberDeviceUsageResponseSchema>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/memberships/device-usage`,
    telemetry: { route: "/v1/workspaces/{workspaceId}/memberships/device-usage", method: "GET", rowsField: "members" },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/memberships/unactivated`
 *
 * List of workspace members that have never logged in
 */
export function getWorkspacesMembershipsUnactivated(
  transport: Transport,
  args: { workspaceId: string },
): Promise<UnactivatedMembersResponseSchema> {
  return transport<UnactivatedMembersResponseSchema>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/memberships/unactivated`,
    telemetry: { route: "/v1/workspaces/{workspaceId}/memberships/unactivated", method: "GET", rowsField: "members" },
  });
}

/**
 * `PATCH /v1/workspaces/{workspaceId}/memberships/{membershipId}/config`
 *
 * Workspace membership config updated successfully
 */
export function patchWorkspacesMembershipsConfig(
  transport: Transport,
  args: { workspaceId: string; membershipId: string; body: UpdateWorkspaceMembershipConfigRequest },
): Promise<UpdateWorkspaceMembershipConfigResponse> {
  return transport<UpdateWorkspaceMembershipConfigResponse>({
    method: "PATCH",
    path: `/v1/workspaces/${args.workspaceId}/memberships/${args.membershipId}/config`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/memberships/{membershipId}/config", method: "PATCH" },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/memberships/{membershipId}/current-routes`
 *
 * One driver's current, upcoming, and just-completed routes
 */
export function getWorkspacesMembershipsCurrentRoutes(
  transport: Transport,
  args: { workspaceId: string; membershipId: string },
): Promise<DriverCurrentRoutes> {
  return transport<DriverCurrentRoutes>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/memberships/${args.membershipId}/current-routes`,
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/memberships/{membershipId}/current-routes",
      method: "GET",
      rowsField: "routes",
    },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/memberships/{membershipId}/hos-clocks`
 *
 * One driver's hours of service
 */
export function getWorkspacesMembershipsHosClocks(
  transport: Transport,
  args: { workspaceId: string; membershipId: string },
): Promise<MembershipHosClocks> {
  return transport<MembershipHosClocks>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/memberships/${args.membershipId}/hos-clocks`,
    telemetry: { route: "/v1/workspaces/{workspaceId}/memberships/{membershipId}/hos-clocks", method: "GET" },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/publishBroadcast`
 *
 * Publish broadcast response
 */
export function postWorkspacesPublishBroadcast(
  transport: Transport,
  args: { workspaceId: string; body: PublishBroadcastRequest },
): Promise<PublishBroadcastResponse> {
  return transport<PublishBroadcastResponse>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/publishBroadcast`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/publishBroadcast", method: "POST" },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/scheduledBroadcasts`
 *
 * Scheduled broadcasts response
 */
export function getWorkspacesScheduledBroadcasts(
  transport: Transport,
  args: { workspaceId: string },
): Promise<GetScheduledBroadcastsResponse> {
  return transport<GetScheduledBroadcastsResponse>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/scheduledBroadcasts`,
    telemetry: { route: "/v1/workspaces/{workspaceId}/scheduledBroadcasts", method: "GET" },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/tags/search`
 *
 * One page of the workspace's carried tag values that contain the search text, each with its tag
 */
export function getWorkspacesTagsSearch(
  transport: Transport,
  args: { workspaceId: string; query: string; limit?: number; offset?: number | null },
): Promise<SearchTagValuesResponse> {
  return transport<SearchTagValuesResponse>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/tags/search`,
    query: { query: args.query, limit: args.limit, offset: args.offset },
    telemetry: { route: "/v1/workspaces/{workspaceId}/tags/search", method: "GET", rowsField: "results" },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/tasks`
 *
 * One page of the workspace's tasks, each with its creator and its subjects. Rows are oldest first by creation, then
 * id. `hasMore` says whether the walk has another page, to be read now with `cursor`; once it is false, `cursor` names
 * the next delta. A cursor this API did not issue, one for another workspace or another log, or one older than the
 * 7-day lookback is a 400, and the client cold-starts
 */
export function getWorkspacesTasks(
  transport: Transport,
  args: { workspaceId: string; since?: string; cursor?: string; limit?: number },
): Promise<TaskPage> {
  return transport<TaskPage>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/tasks`,
    query: { since: args.since, cursor: args.cursor, limit: args.limit },
    telemetry: { route: "/v1/workspaces/{workspaceId}/tasks", method: "GET", rowsField: "tasks" },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/tasks`
 *
 * Which tasks were recorded, a replayed id among them, and which were dropped for an unknown target or view
 */
export function postWorkspacesTasks(
  transport: Transport,
  args: { workspaceId: string; body: TaskWriteRequest },
): Promise<TaskWriteResult> {
  return transport<TaskWriteResult>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/tasks`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/tasks", method: "POST" },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/tasks/pin-boards`
 *
 * One page of the workspace's task pins; a task's latest pin is the one in force. Rows are oldest first by creation,
 * then id. `hasMore` says whether the walk has another page, to be read now with `cursor`; once it is false, `cursor`
 * names the next delta. A cursor this API did not issue, one for another workspace or another log, or one older than
 * the 7-day lookback is a 400, and the client cold-starts
 */
export function getWorkspacesTasksPinBoards(
  transport: Transport,
  args: { workspaceId: string; since?: string; cursor?: string; limit?: number },
): Promise<TaskPinBoardPage> {
  return transport<TaskPinBoardPage>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/tasks/pin-boards`,
    query: { since: args.since, cursor: args.cursor, limit: args.limit },
    telemetry: { route: "/v1/workspaces/{workspaceId}/tasks/pin-boards", method: "GET", rowsField: "pinBoards" },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/tasks/pin-boards`
 *
 * Which pins were recorded, a replayed id among them, and which were dropped for an unknown task or view
 */
export function postWorkspacesTasksPinBoards(
  transport: Transport,
  args: { workspaceId: string; body: TaskPinBoardWriteRequest },
): Promise<TaskWriteResult> {
  return transport<TaskWriteResult>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/tasks/pin-boards`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/tasks/pin-boards", method: "POST" },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/templates`
 *
 * Get workspace templates
 */
export function getWorkspacesTemplates(
  transport: Transport,
  args: { workspaceId: string },
): Promise<GetWorkspaceTemplatesResponse> {
  return transport<GetWorkspaceTemplatesResponse>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/templates`,
    telemetry: { route: "/v1/workspaces/{workspaceId}/templates", method: "GET", rowsField: "templates" },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/templates`
 *
 * Create workspace template
 */
export function postWorkspacesTemplates(
  transport: Transport,
  args: { workspaceId: string; body: CreateWorkspaceTemplateRequest },
): Promise<CreateWorkspaceTemplateResponse> {
  return transport<CreateWorkspaceTemplateResponse>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/templates`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/templates", method: "POST" },
  });
}

/**
 * `PATCH /v1/workspaces/{workspaceId}/templates/{templateId}`
 *
 * Update workspace template
 */
export function patchWorkspacesTemplates(
  transport: Transport,
  args: { workspaceId: string; templateId: string; body: UpdateWorkspaceTemplateRequest },
): Promise<UpdateWorkspaceTemplateResponse> {
  return transport<UpdateWorkspaceTemplateResponse>({
    method: "PATCH",
    path: `/v1/workspaces/${args.workspaceId}/templates/${args.templateId}`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/templates/{templateId}", method: "PATCH" },
  });
}

/**
 * `DELETE /v1/workspaces/{workspaceId}/templates/{templateId}`
 *
 * Delete workspace template
 */
export function deleteWorkspacesTemplates(
  transport: Transport,
  args: { workspaceId: string; templateId: string },
): Promise<void> {
  return transport<void>({
    method: "DELETE",
    path: `/v1/workspaces/${args.workspaceId}/templates/${args.templateId}`,
    telemetry: { route: "/v1/workspaces/{workspaceId}/templates/{templateId}", method: "DELETE" },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/tms-events/{stream}`
 *
 * One page of the stream's events across every subject registered in it: newest first without `since`, everything
 * created after `since` oldest first with it
 */
export function getWorkspacesTmsEvents(
  transport: Transport,
  args: {
    workspaceId: string;
    stream: "driver_event" | "route_event";
    limit?: number;
    cursor?: string;
    since?: string;
  },
): Promise<TmsEventStreamPage> {
  return transport<TmsEventStreamPage>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/tms-events/${args.stream}`,
    query: { limit: args.limit, cursor: args.cursor, since: args.since },
    telemetry: { route: "/v1/workspaces/{workspaceId}/tms-events/{stream}", method: "GET", rowsField: "events" },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/trigger/schedule`
 *
 * Create scheduled broadcast response
 */
export function postWorkspacesTriggerSchedule(
  transport: Transport,
  args: { workspaceId: string; body: CreateWorkspaceScheduledBroadcastRequest },
): Promise<CreateWorkspaceScheduledBroadcastResponse> {
  return transport<CreateWorkspaceScheduledBroadcastResponse>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/trigger/schedule`,
    body: args.body,
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/trigger/schedule",
      method: "POST",
      rowsField: "broadcastRecipients",
    },
  });
}

/**
 * `PUT /v1/workspaces/{workspaceId}/trigger/schedule/{scheduleId}`
 *
 * Update scheduled broadcast response
 */
export function putWorkspacesTriggerSchedule(
  transport: Transport,
  args: { workspaceId: string; scheduleId: string; body: UpdateWorkspaceScheduledBroadcastRequest },
): Promise<UpdateWorkspaceScheduledBroadcastResponse> {
  return transport<UpdateWorkspaceScheduledBroadcastResponse>({
    method: "PUT",
    path: `/v1/workspaces/${args.workspaceId}/trigger/schedule/${args.scheduleId}`,
    body: args.body,
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/trigger/schedule/{scheduleId}",
      method: "PUT",
      rowsField: "broadcastRecipients",
    },
  });
}

/**
 * `GET /v1/workspaces/{workspaceId}/workflowItems`
 *
 * Workflow items response
 */
export function getWorkspacesWorkflowItems(
  transport: Transport,
  args: { workspaceId: string },
): Promise<GetWorkspaceWorkflowItemsResponse> {
  return transport<GetWorkspaceWorkflowItemsResponse>({
    method: "GET",
    path: `/v1/workspaces/${args.workspaceId}/workflowItems`,
    telemetry: { route: "/v1/workspaces/{workspaceId}/workflowItems", method: "GET" },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/workflowItems`
 *
 * Created workflow item
 */
export function postWorkspacesWorkflowItems(
  transport: Transport,
  args: { workspaceId: string; body: CreateWorkspaceWorkflowItemRequest },
): Promise<WsWorkflowItem> {
  return transport<WsWorkflowItem>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/workflowItems`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/workflowItems", method: "POST" },
  });
}

/**
 * `DELETE /v1/workspaces/{workspaceId}/workflowItems/{workflowItemId}`
 *
 * Workflow item deleted successfully
 */
export function deleteWorkspacesWorkflowItems(
  transport: Transport,
  args: { workspaceId: string; workflowItemId: string },
): Promise<void> {
  return transport<void>({
    method: "DELETE",
    path: `/v1/workspaces/${args.workspaceId}/workflowItems/${args.workflowItemId}`,
    telemetry: { route: "/v1/workspaces/{workspaceId}/workflowItems/{workflowItemId}", method: "DELETE" },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/workflowItems/{workflowItemId}/publish`
 *
 * Published workflow item
 */
export function postWorkspacesWorkflowItemsPublish(
  transport: Transport,
  args: { workspaceId: string; workflowItemId: string; body: PublishWorkspaceWorkflowItemRequest },
): Promise<WsPublishedWorkflowItem> {
  return transport<WsPublishedWorkflowItem>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/workflowItems/${args.workflowItemId}/publish`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/workflowItems/{workflowItemId}/publish", method: "POST" },
  });
}

/**
 * `DELETE /v1/workspaces/{workspaceId}/workspaceMemberships/remove`
 *
 * Workspace memberships removed successfully
 */
export function deleteWorkspacesWorkspaceMembershipsRemove(
  transport: Transport,
  args: { workspaceId: string; body: UpdateWorkspaceMembershipRequest },
): Promise<UpdateWorkspaceMembershipResponse> {
  return transport<UpdateWorkspaceMembershipResponse>({
    method: "DELETE",
    path: `/v1/workspaces/${args.workspaceId}/workspaceMemberships/remove`,
    body: args.body,
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/workspaceMemberships/remove",
      method: "DELETE",
      rowsField: "workspaceMemberships",
    },
  });
}

/**
 * `PATCH /v1/workspaces/{workspaceId}/workspaceMemberships/update`
 *
 * Workspace memberships updated successfully
 */
export function patchWorkspacesWorkspaceMembershipsUpdate(
  transport: Transport,
  args: { workspaceId: string; body: UpdateWorkspaceMembershipRequest },
): Promise<UpdateWorkspaceMembershipResponse> {
  return transport<UpdateWorkspaceMembershipResponse>({
    method: "PATCH",
    path: `/v1/workspaces/${args.workspaceId}/workspaceMemberships/update`,
    body: args.body,
    telemetry: {
      route: "/v1/workspaces/{workspaceId}/workspaceMemberships/update",
      method: "PATCH",
      rowsField: "workspaceMemberships",
    },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/{feedId}/items`
 *
 * Feed item published
 */
export function postWorkspacesItems(
  transport: Transport,
  args: { workspaceId: string; feedId: string; body: PublishToWorkspaceFeedRequest },
): Promise<WsItem> {
  return transport<WsItem>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/${args.feedId}/items`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/{feedId}/items", method: "POST" },
  });
}

/**
 * `DELETE /v1/workspaces/{workspaceId}/{feedId}/items/{itemId}`
 *
 * Delete feed item response
 */
export function deleteWorkspacesItems(
  transport: Transport,
  args: { workspaceId: string; feedId: string; itemId: string },
): Promise<DeleteWorksapceFeedItemResponse> {
  return transport<DeleteWorksapceFeedItemResponse>({
    method: "DELETE",
    path: `/v1/workspaces/${args.workspaceId}/${args.feedId}/items/${args.itemId}`,
    telemetry: { route: "/v1/workspaces/{workspaceId}/{feedId}/items/{itemId}", method: "DELETE" },
  });
}

/**
 * `POST /v1/workspaces/{workspaceId}/{feedId}/tts`
 *
 * Text to speech published
 */
export function postWorkspacesTts(
  transport: Transport,
  args: { workspaceId: string; feedId: string; body: PublishTTSRequest },
): Promise<PublishTTSResponse> {
  return transport<PublishTTSResponse>({
    method: "POST",
    path: `/v1/workspaces/${args.workspaceId}/${args.feedId}/tts`,
    body: args.body,
    telemetry: { route: "/v1/workspaces/{workspaceId}/{feedId}/tts", method: "POST" },
  });
}

/**
 * `POST /v1/{workspaceId}/search/feeds`
 *
 * Search feeds results
 */
export function postSearchFeeds(
  transport: Transport,
  args: { workspaceId: string; body: SearchFeedsRequest },
): Promise<SearchFeedsResponse> {
  return transport<SearchFeedsResponse>({
    method: "POST",
    path: `/v1/${args.workspaceId}/search/feeds`,
    body: args.body,
    telemetry: { route: "/v1/{workspaceId}/search/feeds", method: "POST", rowsField: "results" },
  });
}

/**
 * `POST /v1/{workspaceId}/search/messages`
 *
 * Search messages results
 */
export function postSearchMessages(
  transport: Transport,
  args: { workspaceId: string; body: SearchMessagesRequest },
): Promise<SearchMessageResponse> {
  return transport<SearchMessageResponse>({
    method: "POST",
    path: `/v1/${args.workspaceId}/search/messages`,
    body: args.body,
    telemetry: { route: "/v1/{workspaceId}/search/messages", method: "POST", rowsField: "results" },
  });
}
